<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-truck-delivery</v-icon>
          CONDUCTORES
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
          @click:append="cargarLista()"
          @keyup.enter="cargarLista()"
          clearable
        ></v-text-field>

        <v-spacer></v-spacer>
        <v-checkbox
          v-model="incluirInactivos"
          label="Incluir inactivos"
          @change="cargarLista"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirDialogConductor(null)">
          <v-icon>mdi-plus-circle-outline</v-icon> Nuevo conductor
        </v-btn>
      </v-toolbar>

      <v-data-table

        :options.sync="options"
        hide-default-footer
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" @click="abrirDialogConductor(item.ENTE_ID)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon color="red" @click="eliminarConductor(item.ENTE_ID)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.ACTIVO="{ item }">
          {{ item.ACTIVO == "1" ? "ACTIVO" : "INACTIVO" }}
        </template>

          <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>

    <!-- DIALOG CONDUCTOR -->
    <v-dialog v-model="dialogConductor" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-icon class="mb-1">mdi-account-alert</v-icon>
          <span class="headline">Conductor | {{ datosConductor.ENTE_ID }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            
            <v-form ref="formConductor">
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosConductor.ENTE_NOMBRE"
                    label="Nombre "
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field v-model="datosConductor.ENTE_RUC" label="CEDULA">
                  </v-text-field>
                </v-col>

                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="datosConductor.ENTE_TEL"
                    label="Teléfono"
                  >
                  </v-text-field>
                </v-col>
                
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    :rules="validarEmail1"
                    v-model="datosConductor.ENTE_EMAIL1"
                    label="Email principal"
                  >
                  </v-text-field>
                </v-col>
                                                
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarConductor">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="dialogConductor = !dialogConductor">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "ConductorComponent",
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "ENTE_ID" },
      { text: "Nombre", value: "ENTE_NOMBRE" },
      { text: "Cédula", value: "ENTE_RUC" },
      { text: "Email", value: "ENTE_EMAIL1" },
      { text: "Teléfono", value: "ENTE_TEL" },
      { text: "Activo", value: "ACTIVO" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        String(v)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Ingrese un Email válido",
    ],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,
    currentPage: 1,
    pageCount: 0,
    
    incluirInactivos: false,

    dialogConductor: false,
    datosConductor: {
      ENTE_ID: "",
      ENTE_NOMBRE: "",      
      ENTE_TEL: "",      
      ENTE_EMAIL1: "",
      ENTE_RUC: "",
      ING_FECHA:"",
      ING_USUARIO_ID:"",
      MOD_FECHA:"",
      MOD_USUARIO_ID:"",
      TIPO_ENTE_ID:"",      
      ACTIVO: "",
    },

    busqueda: null,
    itemsPerPage: 20,
    creaCond: true,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
    validarEmail1() {
      return this.validarEmail(this.datosConductor.ENTE_EMAIL1);
    },
    
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    validarEmail(email) {
      if (email == "") {
        return [true];
      }
      if (email == null) {
        return [true];
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return ["Email inválido"];
      } else {
        return [true];
      }
    },

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-conductores");
      this.requestApi({
        method: "GET",
        data: {
          incluirInactivos: this.incluirInactivos,
          itemsPerPage: this.itemsPerPage,
          pageCount: this.pageCount,          
          page: this.currentPage,
          sortBy: this.options.sortBy[0],
          sortDesc: this.options.sortDesc[0],

          busqueda: this.busqueda,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data.lista;
          this.pageCount = 10;
          this.setLoadingTable(false);
        })
        .catch((res) => {
            this.setLoadingTable(false);
        })
        .finally(() => {
          this.setLoadingTable(false);
        });
    },

    modificarConductor() {
      this.setUrl("api/modificar-conductor");
      this.requestApi({
        method: "POST",
        data: {
          conductor: this.datosConductor,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
          this.dialogConductor = false;
        })
        .then(() => {});
    },

    abrirDialogConductor(conductorId) {
      this.creaConductor = false;
      if (conductorId == null) {
        this.datosConductor = {
            ENTE_ID: "",
            ENTE_NOMBRE: "",      
            ENTE_TEL: "",      
            ENTE_EMAIL1: "",
            ENTE_RUC: "",
            ING_FECHA:"",
            ING_USUARIO_ID:"",
            MOD_FECHA:"",
            MOD_USUARIO_ID:"",
            TIPO_ENTE_ID:5,
            ACTIVO: 1,
        };
        this.creaConductor = true;
      }
      this.setUrl("api/datos-conductor");
      this.requestApi({
        method: "GET",
        data: {
          CONDUCTOR_ID: conductorId,
        },
      })
        .then((res) => {
          if (res.data.conductor != null) {
            this.datosConductor = res.data.conductor;
          }          
          this.dialogConductor = true;
        })
        .then(() => {});
    },

    eliminarConductor(conductorId) {
      Vue.swal({
        html: "Está seguro de eliminar el conductor ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {

          this.setUrl("api/borrar-conductor");
          this.requestApi({
            method: "POST",
            data: {
              CONDUCTOR_ID: conductorId,
            },
          }).then((res) => {
            //console.log(res);
            this.cargarLista();
            this.alertNotification({ param: { html: res.data.msg } });
          }).catch((res) => {

          });
        }
      });
    },
    guardarConductor() {
      if (!this.$refs.formConductor.validate()) {
        return false;
      }
      if (this.creaConductor == true) {
        this.crearConductor();
      } else {
        this.modificarConductor();
      }
    },
    crearConductor() {
      //console.log(this.datosNotify);
      this.setUrl("api/crear-conductor");
      this.requestApi({
        method: "POST",
        data: {
          conductor: this.datosConductor,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogConductor = false;
          this.cargarLista();
        })
        .catch((res) => {
            this.alertNotification({ param: { html: res.data.msg } });
        }).finally(() => {
          this.setLoadingTable(false);
        });
    },
    handlePageChange() {
      this.cargarLista();
    },
    
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("CONDUCTORES");
    this.cargarLista();
  },
};
</script>
